export default __webpack_public_path__ + "4375c4a3ddc6f637c2ab9a2d7220f91e.png";